import { schema } from "normalizr";

const billingOrder = new schema.Entity(`billingOrder`);

export default billingOrder;
